// Blushi-Skin Theme - Global JavaScript

(function() {
  'use strict';

  // Mobile Menu Toggle
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuClose = document.querySelector('[data-menu-close]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (menuClose && mobileMenu) {
    menuClose.addEventListener('click', () => {
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // Product Quantity Selector
  document.querySelectorAll('[data-quantity-minus]').forEach(button => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('[data-quantity-input]');
      const value = parseInt(input.value, 10);
      if (value > 1) {
        input.value = value - 1;
      }
    });
  });

  document.querySelectorAll('[data-quantity-plus]').forEach(button => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('[data-quantity-input]');
      const value = parseInt(input.value, 10);
      input.value = value + 1;
    });
  });

  // Product Option Selection
  document.querySelectorAll('[data-option-value]').forEach(button => {
    button.addEventListener('click', () => {
      const siblings = button.parentElement.querySelectorAll('[data-option-value]');
      siblings.forEach(sibling => sibling.classList.remove('is-selected'));
      button.classList.add('is-selected');
    });
  });

  // Product Thumbnails
  document.querySelectorAll('[data-thumbnail]').forEach(thumbnail => {
    thumbnail.addEventListener('click', () => {
      const mainImage = document.querySelector('.product__image-main img');
      const thumbnailImg = thumbnail.querySelector('img');
      
      if (mainImage && thumbnailImg) {
        // Get larger version of thumbnail
        const newSrc = thumbnailImg.src.replace(/width=\d+/, 'width=800');
        mainImage.src = newSrc;
        
        // Update active state
        document.querySelectorAll('[data-thumbnail]').forEach(t => t.classList.remove('is-active'));
        thumbnail.classList.add('is-active');
      }
    });
  });

  // Wishlist Toggle (localStorage based)
  const WISHLIST_KEY = 'blushi_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveWishlist(wishlist) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
  }

  function toggleWishlist(productId) {
    const wishlist = getWishlist();
    const index = wishlist.indexOf(productId);
    
    if (index > -1) {
      wishlist.splice(index, 1);
    } else {
      wishlist.push(productId);
    }
    
    saveWishlist(wishlist);
    updateWishlistButtons();
  }

  function updateWishlistButtons() {
    const wishlist = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(button => {
      const productId = button.dataset.productId;
      if (wishlist.includes(productId)) {
        button.classList.add('is-active');
      } else {
        button.classList.remove('is-active');
      }
    });
  }

  document.querySelectorAll('[data-wishlist-toggle]').forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const productId = button.dataset.productId;
      toggleWishlist(productId);
    });
  });

  // Initialize wishlist buttons on page load
  updateWishlistButtons();

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href !== '#') {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });

  // Header scroll effect
  const header = document.querySelector('[data-header]');
  let lastScroll = 0;

  if (header) {
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      
      if (currentScroll > 100) {
        header.style.boxShadow = '0 2px 20px rgba(0, 0, 0, 0.05)';
      } else {
        header.style.boxShadow = 'none';
      }
      
      lastScroll = currentScroll;
    });
  }

})();
